;(() => {
  let pikadayInstance = null
  const modal = document.querySelector('section#modal')
  const openVariantOptions = document.querySelector(
    '.template-product #open-variant-options'
  )

  if (!openVariantOptions) return

  openVariantOptions.addEventListener('click', function () {
    modal.classList.add('active')
    modal.querySelector('main.wrapper').innerHTML = document.querySelector(
      '.product-voucher-options-container'
    ).innerHTML
    bindEventsAfterElementsAddedInModal(modal).catch(function (error) {
      console.error('Error binding modal events:', error)
      if (window.Sentry) {
        Sentry.captureException(error, {
          tags: { function: 'bindEventsAfterElementsAddedInModal' }
        })
      }
    })
  })

  function formatDate(dateString) {
    const date = new Date(dateString)
    const day = date.getDate()
    const month = date.toLocaleString('en-GB', { month: 'long' })
    const year = date.getFullYear()

    return `${day} ${month} ${year}`
  }

  async function bindEventsAfterElementsAddedInModal(modal) {
    const productId = document
      .querySelector('html')
      .getAttribute('data-product-id')
    const allowedDates = await window.getProductDispatchDates(productId)

    if (allowedDates.length === 0) {
      const calendarContainer = modal.querySelector('#calendar-container-2')
      if (calendarContainer) {
        calendarContainer.innerHTML = '<p>No dispatch dates available</p>'
      }
      return
    }

    const allowedDateSet = new Set(allowedDates.map(window.toDateKey))
    const firstAvailableDate = allowedDates[0]

    const step1 = modal.querySelector(
      '.product-voucher-options .step[data-step="1"]'
    )

    const step2 = modal.querySelector(
      '.product-voucher-options .step[data-step="2"]'
    )

    const addToBasketButtonStep2 = step2.querySelector(
      'button#add-variant-to-basket'
    )

    const datePickerField = modal.querySelector('input#dispatch-date-picker-2')
    const selectDate = modal.querySelector('#select-date-2')
    const dispatchDateMessage = modal.querySelector('#dispatch-date-message-2')
    const dispatchDateString = modal.querySelector(
      'span#dispatch-date-string-2'
    )

    if (pikadayInstance) {
      pikadayInstance.destroy()
    }

    pikadayInstance = new Pikaday({
      field: datePickerField,
      bound: false,
      container: modal.querySelector('#calendar-container-2'),
      minDate: firstAvailableDate,
      firstDay: 1, //set first day to a Monday
      onSelect: function (date) {
        const formattedDate = new Intl.DateTimeFormat('en-GB').format(date)
        datePickerField.value = formattedDate
        selectDate.hidden = true
        dispatchDateMessage.hidden = false
        dispatchDateString.textContent = formatDate(date)
        // Enable and focus the button when a date is selected
        addToBasketButtonStep2.disabled = false
        addToBasketButtonStep2.focus()
      },
      disableDayFn: function (date) {
        return !allowedDateSet.has(window.toDateKey(date))
      },
      onOpen: function () {
        this.gotoDate(firstAvailableDate) // Show the correct month
      }
    })

    // Show button but keep it disabled until a date is selected
    addToBasketButtonStep2.hidden = false
    addToBasketButtonStep2.disabled = true

    // Add Enter key support for step 2
    step2.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !addToBasketButtonStep2.disabled) {
        event.preventDefault()
        addToBasketButtonStep2.click()
      }
    })

    const step1Buttons = step1.querySelectorAll('button.variant-option')
    step1Buttons.forEach((button) => {
      button.addEventListener('click', function () {
        step1Buttons.forEach((b) => b.classList.remove('active'))
        button.classList.add('active')

        step1
          .querySelectorAll('footer button')
          .forEach((b) => (b.hidden = true))
        if (button.getAttribute('data-is-voucher') === 'true') {
          step1.querySelector('button#add-variant-to-basket').hidden = false
        } else {
          step1.querySelector('button#select-dispatch-date').hidden = false
        }
      })
    })

    modal.querySelectorAll('button#add-variant-to-basket').forEach((button) => {
      button.addEventListener('click', function () {
        const purchaseType = button.getAttribute('data-purchase-type')
        const dispatchDate =
          purchaseType === 'dispatch_date'
            ? modal.querySelector('input#dispatch-date-picker-2').value
            : 'With Voucher'

        // Validate that a dispatch date has been selected for dispatch_date purchase type
        if (purchaseType === 'dispatch_date' && !dispatchDate) {
          modal.querySelector('#select-date-2').textContent =
            'Please select a dispatch date'
          modal.querySelector('#select-date-2').hidden = false
          modal.querySelector('#select-date-2').style.color = 'red'
          return
        }

        addVariantToCart({
          variantId: button.getAttribute('data-variant-id'),
          sku: button.getAttribute('data-variant-sku'),
          quantity: document.querySelector(
            'section.product-main input[name="quantity"]'
          ).value,
          modal: modal,
          dispatchDate: dispatchDate
        })
      })
    })

    modal
      .querySelector('footer button#select-dispatch-date')
      .addEventListener('click', function () {
        step1.hidden = true
        step2.hidden = false
      })

    modal.querySelector('button#back').addEventListener('click', function () {
      step1.hidden = false
      step2.hidden = true
    })
  }

  async function addVariantToCart({
    variantId,
    sku,
    quantity,
    modal,
    dispatchDate
  }) {
    const productMain = document.querySelector('section.product-main')
    const message = productMain.querySelector(
      'input[name="properties[message]"]'
    )?.value

    //'Select Options' products add to the cart from this modal instead of
    //submitting the product form, so the hidden inputs the Wrapped gift app
    //injects into that form are not part of this request unless we read them
    //out ourselves - without them the gift bag never reaches the cart. see
    //getAdditionalFormFields in cart-functions.js for what these fields are
    const addToCartForm = productMain.querySelector(
      'form[action$="/cart/add"].pdp'
    )
    const { additionalProperties, additionalItemFields } = addToCartForm
      ? getAdditionalFormFields(new FormData(addToCartForm))
      : { additionalProperties: {}, additionalItemFields: {} }

    try {
      await window.addProductToCart({
        variantId: variantId,
        sku: sku,
        quantity: quantity,
        dispatchDate: dispatchDate,
        message: message,
        additionalProperties,
        additionalItemFields
      })

      await updateCartDrawer()
      updateHeaderCartCount()
      setTimeout(openCartDrawer, 50) //needed to ensure animation runs
      modal.querySelector('button.close').click()
    } catch (error) {
      console.error('Error adding product variant to cart:', error)
      if (window.Sentry) {
        Sentry.captureException(error, {
          tags: { function: 'addVariantToCart' }
        })
      }
    }
  }
})()
